import styled, { css } from 'styled-components';
import { layout, typography } from '../theme';

export const ParagraphCSS = css`
  ${typography.BODY}
  margin: 0 0 ${typography.BODY.lineHeight}rem 0;
`;

export const Paragraph = styled.p`
  ${ParagraphCSS}
`;

export const LinkCSS = css`
  color: inherit;
  text-decoration: none;

  &:hover {
    opacity: 0.5;
  }
`;

export const Link = styled.a`
  ${LinkCSS}
`;

export const HeadingOne = styled.h1`
  ${typography.HEADING};
  margin: 0 auto ${100/typography.BASE_FONT_SIZE}rem !important;

  /*
  @media all and (max-width: 1023px) and (min-width: 667px) {
    ${typography.HEADING_TABLET};
    margin-bottom: ${70/typography.BASE_FONT_SIZE}rem !important;
  }
  */

  @media screen and (max-width: 666px) {
    ${typography.HEADING_MOBILE};
    margin-bottom: ${70/typography.BASE_FONT_SIZE}rem !important;
  }

`;

export const HeadingOneCentered = HeadingOne.extend`
  margin: 0 auto;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 100%;
  transform: translate3d(0%, -50%, 0);
`;

export const HeadingTwo = styled.h2`
  ${typography.SUB_HEADING};
  margin: 0 auto ${typography.BODY.lineHeight}rem;
`;

export const HeadingThree = styled.h3`
  ${typography.SUBSUB_HEADING};
  margin: 0 auto ${typography.BODY.lineHeight}rem;
`;

export const Inset = styled.section`
  padding-left: ${layout.SECTION_PADDING}rem;
  padding-right: ${layout.SECTION_PADDING}rem;

  @media all and (max-width: 1023px) and (min-width: 667px) {
    padding-left: ${layout.SECTION_PADDING / 2}rem;
    padding-right: ${layout.SECTION_PADDING / 2}rem;
  }

  @media screen and (max-width: 666px) {
    padding-left: ${20/typography.BASE_FONT_SIZE}rem !important;
    padding-right: ${20/typography.BASE_FONT_SIZE}rem !important;
  }

`;

export const Text = styled.div`
  p { ${ParagraphCSS} }

  a { ${LinkCSS} }
`;

export const TextSmall = Text.extend`
  ${typography.BODY__SMALL}
`;

export const TagBox = styled.div`
  border: 1px solid #AAA;
  padding: ${8/typography.BASE_FONT_SIZE}rem ${14/typography.BASE_FONT_SIZE}rem ${4/typography.BASE_FONT_SIZE}rem;

  ${(props) => props.inline && css`
    display: inline-block;
    margin: 0 0 -1px -1px;
  `}
`;



// WEBPACK FOOTER //
// ./src/elements/index.js